import { render } from "./next-date-on-selector.vue?vue&type=template&id=35f9645a&lang=pug"
import script from "./next-date-on-selector.vue?vue&type=script&lang=js"
export * from "./next-date-on-selector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__